export const countryCodes = [
    { value: "+91", label: "India", flagUrl: "https://flagcdn.com/w40/in.png" },
    { value: "+1", label: "United States", flagUrl: "https://flagcdn.com/w40/us.png" },
    { value: "+44", label: "United Kingdom", flagUrl: "https://flagcdn.com/w40/gb.png" },
    { value: "+61", label: "Australia", flagUrl: "https://flagcdn.com/w40/au.png" },
    { value: "+81", label: "Japan", flagUrl: "https://flagcdn.com/w40/jp.png" },
    { value: "+49", label: "Germany", flagUrl: "https://flagcdn.com/w40/de.png" },
    { value: "+33", label: "France", flagUrl: "https://flagcdn.com/w40/fr.png" },
    { value: "+39", label: "Italy", flagUrl: "https://flagcdn.com/w40/it.png" },
    { value: "+34", label: "Spain", flagUrl: "https://flagcdn.com/w40/es.png" },
    { value: "+86", label: "China", flagUrl: "https://flagcdn.com/w40/cn.png" },
    { value: "+7", label: "Russia", flagUrl: "https://flagcdn.com/w40/ru.png" },
    { value: "+55", label: "Brazil", flagUrl: "https://flagcdn.com/w40/br.png" },
    { value: "+27", label: "South Africa", flagUrl: "https://flagcdn.com/w40/za.png" },
    { value: "+92", label: "Pakistan", flagUrl: "https://flagcdn.com/w40/pk.png" },
    { value: "+62", label: "Indonesia", flagUrl: "https://flagcdn.com/w40/id.png" },
    { value: "+234", label: "Nigeria", flagUrl: "https://flagcdn.com/w40/ng.png" },
    { value: "+971", label: "United Arab Emirates", flagUrl: "https://flagcdn.com/w40/ae.png" },
    { value: "+20", label: "Egypt", flagUrl: "https://flagcdn.com/w40/eg.png" },
    { value: "+82", label: "South Korea", flagUrl: "https://flagcdn.com/w40/kr.png" },
    { value: "+66", label: "Thailand", flagUrl: "https://flagcdn.com/w40/th.png" },
    { value: "+94", label: "Sri Lanka", flagUrl: "https://flagcdn.com/w40/lk.png" },
    { value: "+60", label: "Malaysia", flagUrl: "https://flagcdn.com/w40/my.png" },
    { value: "+64", label: "New Zealand", flagUrl: "https://flagcdn.com/w40/nz.png" },
    { value: "+46", label: "Sweden", flagUrl: "https://flagcdn.com/w40/se.png" },
    { value: "+41", label: "Switzerland", flagUrl: "https://flagcdn.com/w40/ch.png" },
    { value: "+90", label: "Turkey", flagUrl: "https://flagcdn.com/w40/tr.png" },
    { value: "+351", label: "Portugal", flagUrl: "https://flagcdn.com/w40/pt.png" },
    { value: "+48", label: "Poland", flagUrl: "https://flagcdn.com/w40/pl.png" },
    { value: "+31", label: "Netherlands", flagUrl: "https://flagcdn.com/w40/nl.png" },
    { value: "+93", label: "Afghanistan", flagUrl: "https://flagcdn.com/w40/af.png" },
    { value: "+355", label: "Albania", flagUrl: "https://flagcdn.com/w40/al.png" },
    { value: "+213", label: "Algeria", flagUrl: "https://flagcdn.com/w40/dz.png" },
    { value: "+376", label: "Andorra", flagUrl: "https://flagcdn.com/w40/ad.png" },
    { value: "+54", label: "Argentina", flagUrl: "https://flagcdn.com/w40/ar.png" },
    { value: "+374", label: "Armenia", flagUrl: "https://flagcdn.com/w40/am.png" },
    { value: "+32", label: "Belgium", flagUrl: "https://flagcdn.com/w40/be.png" },
    { value: "+975", label: "Bhutan", flagUrl: "https://flagcdn.com/w40/bt.png" },
    { value: "+359", label: "Bulgaria", flagUrl: "https://flagcdn.com/w40/bg.png" },
    { value: "+855", label: "Cambodia", flagUrl: "https://flagcdn.com/w40/kh.png" },
    { value: "+237", label: "Cameroon", flagUrl: "https://flagcdn.com/w40/cm.png" },
    { value: "+1", label: "Canada", flagUrl: "https://flagcdn.com/w40/ca.png" },
    { value: "+56", label: "Chile", flagUrl: "https://flagcdn.com/w40/cl.png" },
    { value: "+57", label: "Colombia", flagUrl: "https://flagcdn.com/w40/co.png" },
    { value: "+506", label: "Costa Rica", flagUrl: "https://flagcdn.com/w40/cr.png" },
    { value: "+385", label: "Croatia", flagUrl: "https://flagcdn.com/w40/hr.png" },
    { value: "+420", label: "Czech Republic", flagUrl: "https://flagcdn.com/w40/cz.png" },
    { value: "+45", label: "Denmark", flagUrl: "https://flagcdn.com/w40/dk.png" },
    { value: "+216", label: "Tunisia", flagUrl: "https://flagcdn.com/w40/tn.png" },
    { value: "+63", label: "Philippines", flagUrl: "https://flagcdn.com/w40/ph.png" },
  ];
  